import React from 'react';
import { Outlet } from 'react-router-dom';
import { Container, CssBaseline } from '@mui/material';

const PublicLayout: React.FC = () => {
  return (
    <>
      <CssBaseline />
      <Container maxWidth="sm" sx={{ mt: 4 }}>
        <Outlet />
      </Container>
    </>
  );
};

export default PublicLayout;
